var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toggle',_vm._g({attrs:{"value":_vm.value,"falseIcon":"unlock","trueIcon":"lock"}},_vm.$listeners),[_c('template',{slot:"trueDescription"},[_vm._t("restrict",[_vm._v("Restrict "+_vm._s(_vm.label))])],2),_vm._v(" "),_c('template',{slot:"falseDescription"},[_vm._t("allow",[_vm._v("Allow "+_vm._s(_vm.label))])],2)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c81ec54e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RestrictedToggle.vue
// module id = ejcI
// module chunks = 1